import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={72}
      height={48}
      viewBox="0 0 72 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48 12C46.8954 12 46 12.8954 46 14V22C46 23.1046 46.8954 24 48 24H62C63.1046 24 64 23.1046 64 22V14C64 12.8954 63.1046 12 62 12H48ZM8 38C8 36.8954 8.89543 36 10 36H18C19.1046 36 20 36.8954 20 38C20 39.1046 19.1046 40 18 40H10C8.89543 40 8 39.1046 8 38ZM24 36C22.8954 36 22 36.8954 22 38C22 39.1046 22.8954 40 24 40H32C33.1046 40 34 39.1046 34 38C34 36.8954 33.1046 36 32 36H24ZM37 38C37 36.8954 37.8954 36 39 36H47C48.1046 36 49 36.8954 49 38C49 39.1046 48.1046 40 47 40H39C37.8954 40 37 39.1046 37 38ZM54 36C52.8954 36 52 36.8954 52 38C52 39.1046 52.8954 40 54 40H62C63.1046 40 64 39.1046 64 38C64 36.8954 63.1046 36 62 36H54Z"
        fill="#D9DDE3"
      />
      <rect
        x={1}
        y={1}
        width={70}
        height={46}
        stroke="#D9DDE3"
        strokeWidth={2}
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-unknown-card" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
